/**
 * Encodes a string to Base64URL (matches Python's base64.urlsafe_b64encode).
 */
export const toWorkstationKey = (value: string): string => {
  const bytes = new TextEncoder().encode(value);
  const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');

  return window.btoa(binString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

/**
 * Decodes a Base64URL string back to a normal string.
 */
export const fromWorkstationKey = (key: string): string => {
  let base64 = key.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) base64 += '=';

  const binString = window.atob(base64);
  const bytes = Uint8Array.from(binString, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};
